import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { MapHelperService } from "../../map-helper.service";
import { TurfHelperService } from 'src/services/turf-helper.service';
import { ImageCacheService } from 'src/app/features/shared/services/ImageCache.service';
import { environment } from "src/environments/environment";
import { LocalStorageService } from 'src/app/features/shared/services/LocalStorage.service';
import { generateNamedPattern } from 'src/assets/js/mapboxPatternGenerator.js';

@Injectable({
  providedIn: "root",
})
export class IconLoadMapService {
  
  constructor(
    private mapHelperService: MapHelperService,
    private imageCacheService: ImageCacheService,
    private turfHelperService: TurfHelperService,
    private localStorageService: LocalStorageService,
    ) {
  }

  async LoadMapixMapIcons() {
    
    
    // this.mapHelperService._map.on("load", () => {
      try {
              var categoryIcons = JSON.parse(this.localStorageService.getUrlMapList());
              await this.imageCacheService.ensureInitialized();
              categoryIcons.forEach((UrlSas) => {
                
                if (
                  UrlSas.url.includes(".png") ||
                  UrlSas.url.includes(".jpg") ||
                  UrlSas.url.includes(".jpeg")
                ) {
                  const cachedDataUrl = this.imageCacheService.getMapixImage(UrlSas.name);
                  if (cachedDataUrl) {
                    // si está en cache, lo carga directo
                    this.mapHelperService._map.loadImage(cachedDataUrl, (error, image) => {
                      if (error) throw error;
                      if (!this.mapHelperService._map.hasImage(UrlSas.name)) {
                        this.mapHelperService._map.addImage(UrlSas.name, image, {
                          sdf: false,
                        });
                      }
                    });
                  } else {
                    // var imageName = UrlSas.name.replace(".png", "");
                    this.mapHelperService._map.loadImage(UrlSas.url, (error, image) => {
                      if (error) throw error;
                      if (!this.mapHelperService._map.hasImage(UrlSas.name))
                        this.mapHelperService._map.addImage(UrlSas.name, image, {
                          sdf: false,
                        });
                    });
                  }
                }
                // this.mapHelperService._map.addImage('marker', 'animated');
              });
              await this.createPatterns();

              if (!this.mapHelperService._map.hasImage("startPoint-pulse")) {
                this.mapHelperService._map.addImage("startPoint-pulse", this.mapHelperService.pulsingDot, {
                  pixelRatio: 2,
                });
              }
            } catch (error) {
              if(!environment.production) console.log(error);
            }
    // });
  }

  LoadCitronellaMapIcons() {
    // this.mapHelperService._map.on("load", () => {
      try {
        if (!this.mapHelperService._map.hasImage("startPoint-pulse")) {
          this.mapHelperService._map.addImage("startPoint-pulse", this.mapHelperService.pulsingDot, {
            pixelRatio: 2,
          });
        }

        if (!this.mapHelperService._map.hasImage("doll-icon")) {
          this.mapHelperService._map.loadImage('/assets/img/doll-icon.png', (error, image) => {
            if (error) {
              console.error("Error al cargar la imagen:", error);
              return;
            }
            this.mapHelperService._map.addImage("doll-icon", image, {
              sdf: false,
            });
          });
        }
        
      } catch (error) {
        if(!environment.production) console.log(error);
      }
    // });
  }

  async createPatterns(){
    await generateNamedPattern(this.mapHelperService._map, "diagonal_l", {
      backgroundColor: "#34eb46",
      lineColor: "#0d00ff",
      pattern: "diagonalLeft"
    });
    
    await generateNamedPattern(this.mapHelperService._map, "diagonal_V", {
      backgroundColor: "#ebd634",
      lineColor: "#ff9100",
      pattern: "vertical"
    });
  }
  
}
